import {
  EXTENSIONS_WHITELIST,
  validateAndConvertFilesToBlob,
} from "../utilities";

export const withImageUploader =
  (WrappedComponent: React.NamedExoticComponent<any>) =>
  (props: any): JSX.Element => {
    const allowedExtensions = EXTENSIONS_WHITELIST.join(", ");
    const handleOnSelectFile = (files: FileList) =>
      validateAndConvertFilesToBlob(files);

    return (
      <WrappedComponent
        {...props}
        allowedExtensions={allowedExtensions}
        onSelectFile={handleOnSelectFile}
      />
    );
  };
